import {
  fetchCategoriesAPI,
  fetchCategoryByIdAPI,
  createCategoriesAPI,
  deleteCategoriesAPI,
  updateCategoryAPI,
} from "./api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { setErrorAlert, setSuccessAlert } from "containers/Toast/slice";

export const fetchCategories = createAsyncThunk(
  "categories/fetchCategories",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetchCategoriesAPI();
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const fetchCategoryById = createAsyncThunk(
  "categories/fetchCategoryById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await fetchCategoryByIdAPI(id);
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const createCategory = createAsyncThunk(
  "categories/createCategory",
  async (category, { rejectWithValue, dispatch }) => {
    try {
      const response = await createCategoriesAPI(category);
      dispatch(setSuccessAlert("Category created successfully!"));
      return response;
    } catch (error) {
      dispatch(setErrorAlert(`Failed to create category`));
      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteCategory = createAsyncThunk(
  "categories/deleteCategory",
  async ({ id, dispatch }, { rejectWithValue }) => {
    try {
      const response = await deleteCategoriesAPI(id);
      dispatch(setSuccessAlert("Category deleted successfully!"));
      return response;
    } catch (error) {
      dispatch(setErrorAlert(`Failed to delete category`));
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateCategory = createAsyncThunk(
  "categories/updateCategory",
  async ({ id, category }, { rejectWithValue, dispatch }) => {
    try {
      const response = await updateCategoryAPI(id, category);
      dispatch(setSuccessAlert("Category updated successfully!"));
      return response;
    } catch (error) {
      dispatch(setErrorAlert(`Failed to update category`));
      return rejectWithValue(error.response.data);
    }
  }
);
